import { atom } from 'jotai';

/**
 * True until mount-time restore makes a terminal decision — restore a session,
 * honour a deep link, skip restore (appointments-first / mobile), or settle on
 * an empty list. The `/scribe/sessions` cold-load hold reads this so it can
 * release without waiting on the session-detail query.
 */
export const sessionListColdRestorePendingAtom = atom(true);
